import axios from "axios";
import {
  SETTINGS_DOCUMENT_TYPE_ERROR,
  SETTINGS_DOCUMENT_TYPE_CLEAR_SNACKBAR,
  SETTINGS_DELETE_DOCUMENT_TYPE_SUCCESS,
  SETTINGS_GET_DOCUMENT_TYPE_LOADING,
  SETTINGS_ADD_DOCUMENT_TYPE_ERROR,
  SETTINGS_ADD_DOCUMENT_TYPE_SUCCESS,
  SETTINGS_ADD_DOCUMENT_TYPE,
  SETTINGS_GET_DOCUMENT_TYPE,
} from "../constants/types";
import queryString from "query-string";

import { server_url } from "../constants/types";
import request from "config/api";

export const fetchDocumentType = (params = {}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_DOCUMENT_TYPE_LOADING,
        payload: {
          loading: true,
        },
      });
      const newParams = {
        PageNumber: params.page ? params.page + 1 : 1,
        PageSize: params.pageSize ? params.pageSize : 10,
      };
      const queryParams = queryString.stringify(newParams);

      request({
        url: `${server_url}/DocumentType`,
        method: "GET",
      })
        .then((response) => {
          dispatch({
            type: SETTINGS_GET_DOCUMENT_TYPE,
            payload: {
              documentType: response.data,
              totalCount: response.data.length,
              loading: false,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_DOCUMENT_TYPE_ERROR,
            payload: {
              status: "error",
              text: "Error occured during getting all DocumentType.",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const addUpdateDocumentType = ({ formData, onSuccess, payload }) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_ADD_DOCUMENT_TYPE,
        payload: {
          loading: true,
        },
      });

      let data = {
        ...formData,
      };

      request({
        method: formData.documentTypeId ? "PUT" : "POST",
        url: `${server_url}/DocumentType${
          formData.documentTypeId ? `/${formData.documentTypeId}` : ""
        }`,
        body: { ...data },
      })
        .then(async (response) => {
          onSuccess();

          dispatch({
            type: SETTINGS_ADD_DOCUMENT_TYPE_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: formData.documentTypeId
                ? "DocumentType updated Successfully"
                : "DocumentType Created Successfully",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_ADD_DOCUMENT_TYPE_ERROR,
            payload: {
              text: "Error occurred during creating documentType data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const documentTypeDelete = ({
  documentTypeId,
  pageModel,
  onSuccess = () => {},
  showSnackbar = true,
}) => {
  console.log("Check the documentTypeDelete Action", documentTypeId);
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_DOCUMENT_TYPE_LOADING,
        payload: {
          loading: true,
        },
      });
      request({
        url: `${server_url}/DocumentType/${documentTypeId}`,
        method: "DELETE",
      })
        .then((response) => {
          dispatch(fetchDocumentType({ ...pageModel }));
          onSuccess();

          dispatch({
            type: SETTINGS_DELETE_DOCUMENT_TYPE_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: "documentType Deleted Successfully",
              loading: false,
              showSnackbar: true,
            },
          });

          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_DOCUMENT_TYPE_ERROR,
            payload: {
              text: "Error occurred during deleting documentType data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const documentTypeClearShowSnackbar = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTINGS_DOCUMENT_TYPE_CLEAR_SNACKBAR,
    });
  };
};
